import { Component, Input, OnInit } from '@angular/core';
import { BaseSearch, SearchBaseRequest, SearchBaseResponse } from '../../../../modules/tcm-core.module';
import { TranslationService } from '../../../../services/translation.service';

@Component({
    selector: 'search-results',
    templateUrl: 'search-results.component.html',
    styleUrls: ['search-results.component.scss'],
    standalone: false
})
export class SearchResultsComponent implements OnInit {

  @Input()
  public search: BaseSearch<SearchBaseRequest, SearchBaseResponse<any>>;

  @Input()
  public noResultsMessage: string;

  public get isReady() {
    return this.search && this.search.viewModel;
  }

  public get isLoading(): boolean {
    return this.search.isLoading;
  };

  public get hasRecords(): boolean {
    return this.search.viewModel.records && this.search.viewModel.records.length > 0;
  };

  constructor(private translationService: TranslationService) { }

  ngOnInit(): void {
    this.noResultsMessage = !this.noResultsMessage ? this.translationService.translate(x => x.Messages.WarningMessages.SearchReturnedNoResults) : this.noResultsMessage;
  }
}
